
/* styles */
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-3c1d4dab&scoped=true!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./JournalVoucher.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./JournalVoucher.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-3c1d4dab!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./JournalVoucher.vue"),
  /* scopeId */
  "data-v-3c1d4dab",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/microfinance/accounting/JournalVoucher.vue
// module id = 707
// module chunks = 0